import { render, staticRenderFns } from "./request.vue?vue&type=template&id=4f6dfbb9&scoped=true"
import script from "./request.vue?vue&type=script&lang=js"
export * from "./request.vue?vue&type=script&lang=js"
import style0 from "./request.vue?vue&type=style&index=0&id=4f6dfbb9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6dfbb9",
  null
  
)

export default component.exports